import { useAuthStore } from "../store/authStore";
import jwtDecode from "jwt-decode";
var setHeader = function (headers, key, value) {
    if (typeof headers.set === "function") {
        headers.set(key, value);
        return;
    }
    headers[key] = value;
};
var getHeader = function (headers, key) {
    var _a, _b, _c;
    if (!headers)
        return "";
    if (typeof headers.get === "function") {
        return (_a = headers.get(key)) !== null && _a !== void 0 ? _a : "";
    }
    return (_c = (_b = headers[key]) !== null && _b !== void 0 ? _b : headers[key.toLowerCase()]) !== null && _c !== void 0 ? _c : "";
};
var isJwtExpired = function (token) {
    try {
        var decoded = jwtDecode(token);
        if (!decoded.exp)
            return true;
        return decoded.exp < Math.floor(Date.now() / 1000);
    }
    catch (_a) {
        return true;
    }
};
export var authRequestInterceptor = function (config) {
    var _a;
    var token = useAuthStore.getState().token;
    config.headers = (_a = config.headers) !== null && _a !== void 0 ? _a : {};
    if (token) {
        setHeader(config.headers, "Authorization", "Bearer ".concat(token));
        setHeader(config.headers, "Cache-Control", "no-cache, no-store, must-revalidate");
        setHeader(config.headers, "Pragma", "no-cache");
        setHeader(config.headers, "Expires", "0");
    }
    return config;
};
export var authRequestErrorInterceptor = function (error) {
    console.error("axiosConfig.ts", error);
    return Promise.reject(error);
};
export var authResponseErrorInterceptor = function (error) {
    var _a, _b;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        var token = useAuthStore.getState().token;
        var authenticateHeader = getHeader(error.response.headers, "www-authenticate");
        var backendRejectedToken = /invalid_token|expired/i.test(authenticateHeader);
        if (!token || isJwtExpired(token) || backendRejectedToken) {
            console.warn("Token expirado o inválido. Redirigiendo a login...");
            useAuthStore.getState().logout();
        }
    }
    if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
        return { data: null };
    }
    return Promise.reject(error);
};
